import React, { useEffect, useState } from "react";
import { Form, InputGroup, Button } from "react-bootstrap";

interface Props {
  label?: string;
  name?: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  showRequired?: boolean;
  error?: string;
  touched?: boolean;
  password: string;
  updateHandler?: any;
  showUpdate?: boolean;
  isDirty?: boolean;
}
const PasswordInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  showRequired,
  error,
  touched,
  password,
  updateHandler,
  showUpdate,
  isDirty,
}: Props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [pass, setPass] = useState(password);

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(password);
  };
  const generatePassword = () => {
    const length = 12;
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
    let generatedPassword = "";
    for (let i = 0; i < length; i++) {
      generatedPassword += charset.charAt(
        Math.floor(Math.random() * charset.length)
      );
    }
    setPass(generatedPassword);
    onChange?.(generatedPassword);
  };

  useEffect(() => {
    setPass(password);
  }, [password]);

  return (
    <Form.Group>
      <Form.Label className="text-uppercase">{label}</Form.Label>
      <InputGroup className="mt-1">
        <Form.Control
          type={showPassword ? "text" : "password"}
          placeholder="Enter password"
          value={pass}
          onChange={(e) => {
            setPass(e.target.value);
            onChange?.(e.target.value);
          }}
        />
        <Button
          variant="outline-primary"
          onClick={togglePasswordVisibility}
          style={{
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            const icon = e.currentTarget.querySelector("i");
            if (icon) icon.style.color = "white";
          }}
          onMouseLeave={(e) => {
            const icon = e.currentTarget.querySelector("i");
            if (icon) icon.style.color = "";
          }}
        >
          <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
        </Button>
        <Button
          variant="outline-primary"
          onClick={generatePassword}
          style={{
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            const icon = e.currentTarget.querySelector("i");
            if (icon) icon.style.color = "white";
          }}
          onMouseLeave={(e) => {
            const icon = e.currentTarget.querySelector("i");
            if (icon) icon.style.color = "";
          }}
        >
          <i className="bi bi-arrow-clockwise"></i>
        </Button>
        {showUpdate && (
          <Button
            className="btn  btn-primary"
            onClick={updateHandler}
            disabled={!isDirty || !password}
          >
            Update
          </Button>
        )}
      </InputGroup>
    </Form.Group>
  );
};

export default PasswordInput;
